import { RouteObject } from'react-router-dom';
import { SupportCenterLanding } from './components/Landing';

export interface supportCenterRoute extends Omit<RouteObject,'children'> {
 auth?: boolean;
 children?: supportCenterRoute[];
}

export const supportCenterRoutes:supportCenterRoute[] = [
 {
 path:'/support-center',
 element: <SupportCenterLanding />,
 },
];
